export type ToastSeverity = 'success' | 'error' | 'warning' | 'info';

export type ToastAnchorOrigin = {
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
};

export interface ToastItem {
  id: string;
  message: string;
  severity: ToastSeverity;
  hideDuration: number | null;
  anchorOrigin: ToastAnchorOrigin;
  actionLabel?: string;
}

export interface ToastState {
  toasts: ToastItem[];
}

export const SHOW_TOAST = 'toast/SHOW';
export const HIDE_TOAST = 'toast/HIDE';
export const HIDE_ALL_TOASTS = 'toast/HIDE_ALL';

const initialState: ToastState = {
  toasts: [],
};

type ToastAction =
  | { type: typeof SHOW_TOAST; payload: ToastItem }
  | { type: typeof HIDE_TOAST; payload: { id: string } }
  | { type: typeof HIDE_ALL_TOASTS };

export default function toastReducer(
  state: ToastState = initialState,
  action: ToastAction
): ToastState {
  switch (action.type) {
    case SHOW_TOAST: {
      if (state.toasts.some((t) => t.id === action.payload.id)) return state;
      return { toasts: [...state.toasts, action.payload] };
    }
    case HIDE_TOAST:
      return { toasts: state.toasts.filter((t) => t.id !== action.payload.id) };
    case HIDE_ALL_TOASTS:
      return { toasts: [] };
    default:
      return state;
  }
}
